import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

import NavLogo from "./navigation/NavLogo";
import { useNavigate } from "react-router-dom";
import { CommunicationBoardOptions } from "../utils";

const CommunicationBoardInterface = ({ isModal = false, isOpen = true, closeFun = null }) => {

    const navigate = useNavigate();

    const boardOptions = CommunicationBoardOptions;

    const handleBoardOptionSelect = (option) => {
        navigate(`/cb/${option.module}`);
        if (closeFun) {
            closeFun(false);
        }
    };



    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[100]" open={isOpen} onClose={() => closeFun && closeFun(false)}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 xbg-red-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end md:items-center justify-center p-0 md:p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-0 md:rounded-lg bg-white xbg-orange-500 text-left shadow-xl transition-all w-full md:max-w-5xl h-[100vh] md:h-[calc(100vh-10rem)] lg:max-h-[800px]">
                                <div className={`xbg-yellow-500 px-0 pb-0 ${isModal ? 'h-full w-full pt-0' : 'h-[96vh] w-full md:w-full md:max-w-5xl md:mx-20 pt-14'} relative transform overflow-hidden text-left shadow-xl transition-all`}>
                                    <div className="xbg-green-500 bg-white h-full mx-0 rounded-none md:rounded-md flex flex-col overflow-hidden">

                                        <div className="xbg-blue-500 bg-gray-100 px-3 md:px-4 py-2 md:py-3 border-b border-gray-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:gap-0">

                                            <div className='flex flex-row items-center gap-x-1 w-full md:w-auto justify-between md:justify-start'>
                                                <div className="flex items-center gap-x-1">
                                                    <NavLogo />
                                                    <b className="logo-font menu-link-logo-cls text-sm md:text-base md:hidden">we</b>
                                                    <b className="logo-font logo-light menu-link-logo-cls text-sm md:text-base md:hidden">fayo</b>
                                                    <b className="logo-font logo-light menu-link-logo-cls text-sm md:text-base hidden md:inline">Communication Tools</b>
                                                </div>
                                                {isModal && closeFun && (
                                                    <button
                                                        onClick={() => closeFun(false)}
                                                        className="text-gray-500 hover:text-gray-700 focus:outline-none md:hidden"
                                                    >
                                                        <span className="sr-only">Close</span>
                                                        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                        </svg>
                                                    </button>
                                                )}
                                            </div>
                                            <h2 className="text-sm md:text-base font-semibold leading-5 md:leading-6 text-gray-900 flex-1 md:flex-none w-full md:w-auto">
                                                Select a communication tool <span className="hidden md:inline">that best fits your needs</span>
                                            </h2>
                                            {isModal && closeFun && (
                                                <button
                                                    onClick={() => closeFun(false)}
                                                    className="text-gray-500 hover:text-gray-700 focus:outline-none hidden md:block md:pl-[111.6px]"
                                                >
                                                    <span className="sr-only">Close</span>
                                                    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </button>
                                            )}
                                        </div>

                                        <div className="xbg-purple-500 flex-1 p-3 md:p-6 md:max-h-[684px] relative flex flex-col justify-start md:justify-start items-start overflow-y-auto ">
                                            <div className="xbg-pink-500 grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-8 w-full">
                                                {boardOptions.map((option) => {
                                                    return (
                                                        <button
                                                            key={option.id}
                                                            onClick={() => handleBoardOptionSelect(option)}
                                                            className="h-auto md:h-[270px] flex flex-col items-center p-2 md:p-4 rounded-lg border-2 border-gray-200 hover:border-purple-600 hover:shadow-md transition-all duration-200 group text-left relative disabled:opacity-50 disabled:cursor-not-allowed"
                                                        >
                                                            <div className="w-full flex flex-col items-center gap-x-2 md:gap-x-0">
                                                                <div className="w-[80px] h-[80px] md:w-[144px] md:h-[144px] bg-purple-50 rounded-full flex items-center justify-center p-2 md:p-3 mb-2 md:mb-3 group-hover:bg-purple-200 transition-colors duration-200">
                                                                    <img
                                                                        alt={option.name}
                                                                        src={option.icon}
                                                                        className="w-[60px] h-auto md:w-[120px]"
                                                                        style={{ maxWidth: "100%", height: option?.iconHeight ?? 'auto', minHeight: option?.minHeight ?? 'auto' }}
                                                                    />
                                                                </div>
                                                                <div className="flex flex-col items-center w-full">
                                                                    <h3 className="font-bold text-purple-900 mb-1 md:mb-2 text-xs md:text-lg text-center leading-tight">{option.name}</h3>
                                                                    <p className="text-[10px] md:text-sm text-gray-500 text-center font-medium md:font-bold leading-tight">
                                                                        {option.description}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default CommunicationBoardInterface;